import { CAlert, CButton, CModal, CModalBody, CModalFooter } from '@coreui/react';
import * as React from 'react';

interface IProps {
	isOpen: boolean;
	title: string;
	message: string;
	yesText: string;
	noText: string;
	closeCallBack: (yesNo: boolean) => any;

	duration?: number;
}

interface IState {
	timeOut: number;
}

export class KConfirmPopup extends React.Component<IProps, IState> {
	public constructor(props: any) {
		super(props);

		this.state = {
			timeOut: (this.props.duration ? this.props.duration  : 0),
		};
	}

	private intervalHdlr: any;

	//#region React Hacks
	
	UNSAFE_componentWillMount = () => {
		let timeOut = this.props.duration ? this.props.duration : 20;
		if (timeOut > 0) {	// Un time out est défini
			// On déclenche un timer qui sera appelé toutes les secondes
			this.intervalHdlr = setInterval(() => {
				// Ce timer va réduire le temps restant à attendre avant fermeture
				this.setState({ timeOut: this.state.timeOut - 1 }, () => {
					// Si on est arrivé à 0, on ferme la fenêtre
					if (this.state.timeOut == 0) this.close(false);
				});
			}, 1000)
		}
		this.setState({ timeOut: timeOut });
	}

	// pour éviter les comportement hasardeux, on coupe le timer lorsque le composant est supprimé
	componentWillUnmount = () => {
		clearInterval(this.intervalHdlr);
	}

	//#endregion React Hacks

	//#region Local events

	close = (YesNo: boolean): void => {
		clearTimeout(this.intervalHdlr);
		if (this.props.closeCallBack) this.props.closeCallBack(YesNo);
	}

	//#endregion 

	render() {

		// On prépare le texte OK (N) avec N = temps avant fermeture auto
		let noTxt = this.props.noText;
		if (this.state.timeOut > 0) {
			noTxt += " (" + this.state.timeOut + ")"
		}

		return (
			<CModal centered closeOnBackdrop={false} className={"KAlertPopup "} show={this.props.isOpen} onClose={() => this.close(false)} >

				<CModalBody>
					<CAlert color="info">
						<h4 className="alert-heading">{this.props.title}</h4>
						{this.props.message}
					</CAlert>
				</CModalBody>

				<CModalFooter>
					<CButton color='success' onClick={() => this.close(true)}>✓ {this.props.yesText}</CButton>
					<CButton color='danger' onClick={() => this.close(false)}>✖ {noTxt}</CButton>
				</CModalFooter>
			</CModal>
		);
	}
}
